var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"see_more",on:{"click":_vm.seemore}},[_c('p',{staticClass:"hoverClass"},[_vm._v(_vm._s('<<<查看更多>>>'))])])}
var staticRenderFns = []

export { render, staticRenderFns }